import React, {type JSX} from 'react';
import {Box, Button, Typography} from '@mui/material';
import {Grid} from '@mui/system';
import {styled} from '@mui/material/styles';
import {BlockContainer, VimeoVideoPlayer} from './shared';

const VIMEO_VIDEO_ID = '814694374';

export const STOP_FAXING_LIST = [
  {
    id: 1,
    text: 'Reduce time wasted chasing records by 90%.',
  },
  {
    id: 2,
    text: 'Access consolidated patient records instantly.',
  },
  {
    id: 3,
    text: 'Eliminate delays in care due to missing records.',
  },
];

const StyledConnectUsButton = styled(Button)(({theme}) => ({
  '&.MuiButton-root': {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: theme.spacing(2.25),
    lineHeight: theme.spacing(3),
    padding: theme.spacing(2),
    minHeight: theme.spacing(6.25),
  },
}));

const StyledVideoContainer = styled(Box)(({theme}) => ({
  width: '100%',
  height: 0,
  paddingBottom: '56.25%',
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    paddingBottom: '75%',
  },
}));

const StyledTextContainer = styled(Box)(({theme}) => ({
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));

function StopFaxingBlock(): JSX.Element {
  return (
    <BlockContainer withBackground grow={1}>
      <Grid container spacing={6}>
        {/* Video Section */}
        <Grid size={{xs: 12, sm: 6}}>
          <StyledVideoContainer>
            <VimeoVideoPlayer testId="finish-page" videoId={VIMEO_VIDEO_ID} />
          </StyledVideoContainer>
          <Typography component="h5" variant="h5" align="center" marginTop={3}>
            Watch now to learn more
          </Typography>
        </Grid>
        <Grid size={{xs: 12, sm: 6}}>
          <StyledTextContainer>
            <Typography
              component="h4"
              variant="h4"
              sx={{
                marginBottom: '16px',
              }}
            >
              Stop faxing and join Health Bank One™ today.
            </Typography>
            <Typography
              component="p"
              variant="body4"
              sx={{
                marginBottom: '16px',
              }}
            >
              Health Bank One is a completely new system that consolidates a
              patient's medical records from every provider and puts them in one
              secure place, so doctors can finally access complete records at
              any time.
            </Typography>
            <ul>
              {STOP_FAXING_LIST.map(({id, text}) => (
                <li key={id}>
                  <Typography component="p" variant="body4">
                    {text}
                  </Typography>
                </li>
              ))}
            </ul>
            <Typography component="p" variant="body4">
              Contact us to learn more or request a demo.
            </Typography>
            <Box marginTop={5}>
              <StyledConnectUsButton
                href="mailto:support@healthbankone.com"
                data-testid="contact-us-btn"
                variant="contained"
              >
                Contact Us
              </StyledConnectUsButton>
            </Box>
          </StyledTextContainer>
        </Grid>
      </Grid>
    </BlockContainer>
  );
}

export default StopFaxingBlock;
